import ExcelJS from "exceljs";

export const exportCoolingCapacityExcel = async (
  temperaturesModel,
  modelData,
  withHavaDebili,
  preventDownload = false
) => {
  console.log(modelData, "modelData");
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Cooling Capacity");

  // Tüm satırları başta oluştur
  const totalRows = modelData.length + 3; // header rows + data rows
  for (let i = 1; i <= totalRows; i++) {
    worksheet.addRow([]);
  }

  // Başlık satırı
  const headerRow = worksheet.getRow(1);
  headerRow.getCell(1).value = "Model";
  headerRow.getCell(2).value = "İç Ortam Sıcaklığı [°C]";
  headerRow.getCell(3).value = "Ortam Nemi";
  headerRow.getCell(4).value = "Dış Ortam Sıcaklığı [°C]";

  // Alt başlık satırı
  const subHeaderRow1 = worksheet.getRow(2);
  subHeaderRow1.getCell(2).value = "[°C]";
  worksheet.mergeCells("B2:B3");
  subHeaderRow1.getCell(3).value = "%";
  worksheet.mergeCells("C2:C3");

  // Sıcaklık değerlerini ekle
  const temperatures = temperaturesModel;
  let colIndex = 4; // D sütunundan başla

  temperatures.forEach((temp, index) => {
    const tempCell = worksheet.getRow(2).getCell(colIndex);
    tempCell.value = temp;

    // kWf, kWs, kWe ve withHavaDebili ise m3/h değerleri
    worksheet.getRow(3).getCell(colIndex).value = "kWf";
    worksheet.getRow(3).getCell(colIndex + 1).value = "kWs";
    worksheet.getRow(3).getCell(colIndex + 2).value = "kWe";

    if (withHavaDebili) {
      worksheet.getRow(3).getCell(colIndex + 3).value = "m3/h";
    }

    if (index === temperatures.length - 1) {
      worksheet.mergeCells(1, 4, 1, colIndex + 3);
    }

    // Sıcaklık hücrelerini birleştir
    if (withHavaDebili) {
      worksheet.mergeCells(2, colIndex, 2, colIndex + 3);
      colIndex += 4;
    } else {
      worksheet.mergeCells(2, colIndex, 2, colIndex + 2);
      colIndex += 3;
    }
  });

  // Model başlığını birleştir
  worksheet.mergeCells("A1:A3");

  // Model verilerini ekle
  modelData.forEach((row, index) => {
    const dataRow = worksheet.getRow(index + 4);

    dataRow.getCell(1).value = row.model;
    dataRow.getCell(2).value = row.evaporatorAirInletTemp;
    dataRow.getCell(3).value = row.evaporatorAirInletHumidity;

    let dataColIndex = 4;
    row.temps.forEach((temp) => {
      dataRow.getCell(dataColIndex).value = temp.coolingCapacity;
      dataRow.getCell(dataColIndex + 1).value = temp.sensibleCapacity;
      dataRow.getCell(dataColIndex + 2).value = temp.compressorPower;
      if (withHavaDebili) {
        dataRow.getCell(dataColIndex + 3).value = temp.condFanAirFlow;
        dataColIndex += 4;
      } else {
        dataColIndex += 3;
      }
    });
  });

  // Stil ayarları
  worksheet.columns.forEach((column) => {
    column.width = 10;
    column.alignment = { horizontal: "center" };
  });

  // Başlık stillerini ayarla
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(2).font = { bold: true };

  let table = `
    <div style="
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      margin-bottom: 1rem;
      background: white;
      box-shadow: 0 1px 3px rgba(0,0,0,0.12);
    ">
     
      <table class="cooling-capacity-table" style="
        border-collapse: collapse;
        width: 100%;
        min-width: 800px;
        font-size: 14px;
        position: relative;
      ">`;

  // Border'ları ekle
  worksheet.eachRow((row) => {
    table += `<tr style="
      border-bottom: 1px solid #e0e0e0;
      transition: background-color 0.2s ease;
    ">`;
    const cells = row["_cells"];
    cells.forEach((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      table += `<td style="
        padding: 12px 8px;
        text-align: center;
        border: 1px solid #e0e0e0;
        white-space: nowrap;
        transition: all 0.2s ease;
        position: relative;
      "> ${cell.value || ""}</td>`;
    });
    table += "</tr>";
  });

  table += `
      </table>
    </div>`;

  console.log(table);

  // Excel dosyasını kaydet
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  if (preventDownload) return { html: table, blob };
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "cooling_capacity.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
};
